import { parsePhoneNumberFromString } from 'libphonenumber-js';

const formatPhoneNumber = (phoneNumber) => {
  // Ensure the phone number starts with a '+' for country detection
  const adjustedPhoneNumber = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;

  // Parse and format the number
  const parsedPhoneNumber = parsePhoneNumberFromString(adjustedPhoneNumber);
  if (parsedPhoneNumber) {
    return parsedPhoneNumber.formatInternational(); // Formats to international format
  }

  // Return the original number if parsing fails
  return phoneNumber;
};

export default formatPhoneNumber;